export { default as ScreenProductList } from './list'
export { default as ScreenProductAdd } from './add'
export { default as ScreenProductDetail } from './detail'
export { default as ScreenProductEdit } from './edit'
export { default as ScreenProductTransfer } from './transfer'
